// import styled from 'styled-components';

// /* ===== Identidade visual (alinhada ao login / Header) =====
//    --border: rgba(216, 224, 235, 0.9)
// =========================================================== */

// export const Container = styled.div`
//   flex: 1;
//   display: flex;
//   flex-direction: column;
//   gap: 10px;
//   width: 100%;
//   max-width: 280px;
//   padding: 12px;

//   background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
//   border: 1px solid rgba(216, 224, 235, 0.9);
//   border-radius: 16px;
//   box-shadow: 0 10px 30px rgba(23, 38, 59, 0.06),
//     0 1px 0 rgba(255, 255, 255, 0.9) inset;
// `;

// export const Wrapper = styled.div`
//   flex: 1;
//   min-height: 0;
//   width: 100%;
//   overflow-y: auto;
// `;

import styled from 'styled-components';

/* ===== Identidade visual (alinhada ao login / Header) =====
   --border: rgba(216, 224, 235, 0.9)

   O "card" (fundo, borda e sombra) passou a ser responsabilidade do painel
   lateral em pages/Home/Classificacao/styles.js (Menu.Content). Aqui o
   componente apenas se acomoda ao container, sem largura máxima fixa —
   antes o max-width de 280px limitava a leitura dos níveis da árvore.
=========================================================== */

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;

  min-height: 0;
  width: 100%;
`;

export const Wrapper = styled.div`
  flex: 1;
  min-height: 0;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
